import {
  CircularProgress,
  CircularProgressProps,
  Grid,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import React from 'react';

type LoadingIndicatorProps = {
  text?: string;
  fullHeight?: boolean;
  overlay?: boolean;
  properties?: CircularProgressProps;
  sx?: SxProps<Theme>;
};

export const LoadingIndicator = React.forwardRef<
  HTMLDivElement,
  LoadingIndicatorProps
>((props, ref) => {
  const { text, fullHeight, overlay, properties = {} } = props;
  const style: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    height: fullHeight ? '100%' : undefined,
    ...(overlay && {
      position: 'absolute',
      width: '100%',
      height: '100%',
      'z-index': 1100,
      background: '#000000',
      opacity: 0.4,
      top: 0,
      left: 0,
    }),
    ...props.sx,
  };

  return (
    <Grid ref={ref} container={true} sx={style}>
      <CircularProgress size={24} {...properties} />
      {text && <br />}
      {text && <Typography>{text}</Typography>}
    </Grid>
  );
});

LoadingIndicator.displayName = 'LoadingIndicator';
